import React from 'react';
import ReactDOM, { unmountComponentAtNode } from 'react-dom';
import { HashRouter } from 'react-router-dom';
import { I18nextProvider } from "react-i18next";
import XwordMain from './Xword';
import i18n from "./Localization";

import './index.scss';
import './Xword.css';
if (process.env.REACT_APP_THEME) {
  require(`./Themes/${process.env.REACT_APP_THEME}.scss`)
}

function load() {
  ReactDOM.render(
    (<HashRouter settings={window.pzzl}>
       <I18nextProvider i18n={i18n}>
         <XwordMain />
       </I18nextProvider>
    </HashRouter>),
    document.getElementById('pzzl-xword')
  );
}

window.addEventListener("load", () => {
  if (window.pzzl) {
    //process settings variable from host page
    const { xword } = window.pzzl
    if (xword) {
      if (xword.reload) {
        //overwrite reload function
        window.pzzl.xword.reload = function() {
          unmountComponentAtNode(document.getElementById('pzzl-xword'));
          load();
        }
      }
    }
  }
});

load();
